"use client";

import { useTranslations } from "next-intl";
import Link from "next/link";

export function Footer() {
  const t = useTranslations("Footer");

  return (
    <footer className="border-t border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="text-center space-y-4">
          {/* Copyright */}
          <div className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Adrian y Anita Online. {t("allRightsReserved")}
          </div>
          
          {/* Legal Links */}
          <div className="flex justify-center items-center gap-6 text-sm">
            <Link 
              href="/privacy-policy" 
              className="text-muted-foreground hover:text-primary transition-colors underline"
            >
              {t("privacyPolicy")}
            </Link>
            <span className="text-muted-foreground">•</span>
            <Link 
              href="/terms-of-use" 
              className="text-muted-foreground hover:text-primary transition-colors underline"
            >
              {t("termsOfUse")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
